import { useEffect, useRef, useState } from "react";
import styled, { keyframes } from "styled-components";
import { tokens } from "../styles";

const appear = keyframes`
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: none; }
`;

const Box = styled.div`
  position: relative;
  background: ${tokens.cream2};
  border-radius: 6px;
  animation: ${appear} 0.16s ease-out both;
  @media (prefers-reduced-motion: reduce) { animation: none; }
`;
const Pre = styled.pre`
  margin: 0;
  padding: 14px 64px 14px 16px;
  overflow-x: auto;
  font-family: ${tokens.mono};
  font-size: 11.5px;
  line-height: 1.6;
  color: ${tokens.body};
  white-space: pre;
`;
const Copy = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  font: inherit;
  font-size: 12px;
  color: ${tokens.soft};
  background: ${tokens.cream2};
  border: 0;
  padding: 2px 4px;
  cursor: pointer;
  &:hover { color: ${tokens.blue}; }
`;

export default function BibBlock({ bibtex, className }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef(0);
  useEffect(() => () => clearTimeout(timer.current), []);

  const copy = async () => {
    try { await navigator.clipboard.writeText(bibtex); } catch (e) { return; }
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), 1600);
  };

  return (
    <Box className={className}>
      <Pre>{bibtex}</Pre>
      <Copy type="button" onClick={copy}>{copied ? "copied" : "copy"}</Copy>
    </Box>
  );
}